import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { hasPermission } from "utils/permissionHelper";
import { MODULES } from "constants/modulesTypes";
import { PERMISSIONS } from "constants/permissionTypes";
import React, { useEffect, useCallback, useRef } from "react";

// Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import withRouter from "components/Common/withRouter";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const location = useLocation();
  const ref = useRef();
  const sidebarRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("authUser"));
  const role = user?.Role;

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); 

        const parent3 = parent2.parentElement; 
        if (parent3) {
          parent3.classList.add("mm-active"); 
          parent3.childNodes[0].classList.add("mm-active"); 
          const parent4 = parent3.parentElement; 
          if (parent4) {
            parent4.classList.add("mm-show"); 
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); 
              parent5.childNodes[0].classList.add("mm-active"); 
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); 
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; 
            if (parent4) {
              parent4.classList.remove("mm-show"); 
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); 
                parent5.childNodes[0].classList.remove("mm-active"); 
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const ul = document.getElementById("side-menu");

    if (!ul) {
      return;
    }

    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    let matchingMenuItem = null;

    for (let i = 0; i < items.length; ++i) {
      if (items[i].getAttribute("href") === location.pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    } else {
      console.log("NO MATCH FOUND");
    }
  }, [location.pathname, activateParentDropdown]);

  const permissionMap = useSelector(
    state => state.permissions?.permissions || {}
  );

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      activeMenu();
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname, permissionMap]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebarElement = sidebarRef.current;

      if (
        sidebarElement &&
        !sidebarElement.contains(event.target)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const closeSidebar = () => {
    document.body.classList.remove("sidebar-enable");
    document.body.classList.remove("vertical-collpsed");
  };

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu" ref={sidebarRef}>
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            {role === "Student" ? (
              <>
                <li>
                  <Link to="/dashboard" onClick={closeSidebar} className="waves-effect">
                    <i className="ti-home"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/class-confirmation" onClick={closeSidebar} className="waves-effect">
                    <i className="ti-check-box"></i>
                    <span>{props.t("Class Confirmation")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/notifications" onClick={closeSidebar} className="waves-effect">
                    <i className="ti-bell"></i>
                    <span>{props.t("Notifications")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/reports" onClick={closeSidebar} className="waves-effect">
                    <i className="ti-files"></i>
                    <span>{props.t("Reports")}</span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                {hasPermission(permissionMap, MODULES.DASHBOARD, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/dashboard" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-home"></i>
                      <span>{props.t("Dashboard")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.CONTACTENQUIRIES, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/contact-enquiries" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-agenda"></i>
                      <span>{props.t("Contact Enquiries")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.ROLES, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/roles" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-id-badge"></i>
                      <span>{props.t("Roles")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.USERS, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/users" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-user"></i>
                      <span>{props.t("Users")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.BATCHES, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/batches" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-layout-list-thumb"></i>
                      <span>{props.t("Batches")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.STUDENTS, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/students" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-save-alt"></i>
                      <span>{props.t("Students")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.FINALLIST, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/students-final-list" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-calendar"></i>
                      <span>{props.t("Final List")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.ATTENDANCE, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/attendance-list" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-layout-cta-left"></i>
                      <span>{props.t("Attendance List")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.PAYMENTS, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/payments" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-wallet"></i>
                      <span>{props.t("Payments")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.HOLIDAYS, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/holidays" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-calendar"></i>
                      <span>{props.t("Holidays")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.NOTIFICATIONS, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/notifications" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-bell"></i>
                      <span>{props.t("Notifications")}</span>
                    </Link>
                  </li>
                )}
                {hasPermission(permissionMap, MODULES.REPORTS, PERMISSIONS.VIEW) && (
                  <li>
                    <Link to="/reports" onClick={closeSidebar} className="waves-effect">
                      <i className="ti-files"></i>
                      <span>{props.t("Reports")}</span>
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
